import { defineWidget } from '../../widget-types';

/**
 * Loyalty shell — the personalized top of a mobile-app style home page:
 * greeting ("Hello, {name}" + member QR token) and the points/order-status
 * card. Rendered entirely by storefront code (self-fetching server component);
 * the page editor shows it as a locked, movable block. One type serves every
 * loyalty-app tenant (Cside, Subscrub, …) — it parametrizes by tenant at
 * runtime, nothing tenant-specific is stored in the config.
 */
export const loyaltyShellWidget = defineWidget({
  type: 'code:loyalty-shell',
  schema: {
    label: 'Member Shell',
    description: 'Greeting, member QR and points/order-status card (managed by the system)',
    props: {},
    slots: {},
    dataDeps: [],
  },
  nameTh: 'ส่วนหัวสมาชิก',
  descriptionTh: 'คำทักทาย คะแนนสะสม และสถานะคำสั่งซื้อ (ระบบจัดการให้)',
  category: 'templates',
  thumbnail: '/widget-thumbnails/loyalty-shell.svg',
  defaults: {
    type: 'code:loyalty-shell',
    props: {},
  },
});
